import React, { FC, useState } from 'react';
import Svg from 'svg-inline-react';
import FrCloseSvg from '@src/svgs/fr-close.svg';
import { KeyboardNoticeProps } from './props';
import './styles.scss';

export const KeyboardNotice: FC<KeyboardNoticeProps> = ({ localStorageKey }) => {
  const countString = localStorage.getItem(localStorageKey);
  const countNumber = countString ? parseInt(countString) : 0;

  const [isNoticeVisible, setIsNoticeVisible] = useState<boolean>(countNumber < 2);

  const onClose = () => {
    localStorage.setItem(localStorageKey, `${countNumber + 1}`);
    setIsNoticeVisible(false);
  };

  if (!isNoticeVisible) {
    return null;
  }

  return (
    <div className="keyboard-notice">
      <h4 className="keyboard-notice__title">Keyboard shortcuts</h4>

      <div className="keyboard-notice__actions">
        <div className="keyboard-notice__action">
          <span className="keyboard-notice__action-arrow">◀</span>
          Left
        </div>

        <div className="keyboard-notice__action">
          <span className="keyboard-notice__action-arrow">▶</span>
          Right
        </div>
      </div>

      <Svg className="keyboard-notice__close" onClick={onClose} src={FrCloseSvg} />
    </div>
  );
};
